import BibleBook from './BibleBook';
import BibleChapter from './BibleChapter';

export default class BibleVerse {

    constructor(private readonly index: number, private readonly verseNumber: number,
        private readonly name: string, private readonly shortName: string,
        private readonly book: BibleBook, private readonly chapter: BibleChapter) {
    }

    public getIndex(): number {
        return this.index;
    }

    public getNumber(): number {
        return this.verseNumber;
    }

    public getName(): string {
        return this.name;
    }

    public getShortName(): string {
        return this.shortName;
    }

    public getBook(): BibleBook {
        return this.book;
    }

    public getChapter(): BibleChapter {
        return this.chapter;
    }
}
